import "@mantine/core/styles.css"
import "@mantine/notifications/styles.css"
import "@mantine/dates/styles.css"
import "@mantine/dropzone/styles.css"
import "pretendard/dist/web/static/pretendard.css"
import "@mantine/carousel/styles.css"
import "./app.css"

import { Provider as NiceModalProvider } from "@ebay/nice-modal-react"
import { ColorSchemeScript, mantineHtmlProps, MantineProvider } from "@mantine/core"
import { Notifications } from "@mantine/notifications"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { isRouteErrorResponse, Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router"
import type { Route } from "./+types/root"
import type { PropsWithChildren } from "react"

const queryClient = new QueryClient()

// Root layout component
export function Layout({ children }: PropsWithChildren) {
  return (
    <html lang="ko" {...mantineHtmlProps}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <ColorSchemeScript />
        <Meta />
        <Links />
      </head>
      <body>
        <QueryClientProvider client={queryClient}>
          <MantineProvider>
            <Notifications />
            <NiceModalProvider>{children}</NiceModalProvider>
          </MantineProvider>
          <ReactQueryDevtools />
        </QueryClientProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export default function App() {
  return <Outlet />
}

export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
  let message = "오류가 발생했습니다."
  let details = "예상치 못한 오류가 발생했습니다."
  let stack: string | undefined

  if (isRouteErrorResponse(error)) {
    message = error.status === 404 ? "페이지를 찾을 수 없습니다." : "오류가 발생했습니다."
    details =
      error.status === 404 ? "요청한 페이지를 찾을 수 없습니다." : error.statusText || details
  } else if (import.meta.env.DEV && error && error instanceof Error) {
    details = error.message
    stack = error.stack
  }

  return (
    <main>
      <h1>{message}</h1>
      <p>{details}</p>
      {stack && (
        <pre>
          <code>{stack}</code>
        </pre>
      )}
    </main>
  )
}
